import { render, staticRenderFns } from "./ModalCadastroConfiguracaoPonto.vue?vue&type=template&id=38042c29"
import script from "./ModalCadastroConfiguracaoPonto.vue?vue&type=script&lang=js"
export * from "./ModalCadastroConfiguracaoPonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports